import Statement from "../js/components/billingManagement/Statement.react";
export default Statement;
